import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type IProps = {
  children: ReactNode
  title: string
}
const FormHeader: FC<IProps> = ({ children, title }) => {
  const { t } = useTranslation()
  return (
    <div className='mb-4 h-12 flex items-center justify-between bg-transparent'>
      <p className='font-medium'>{t(`${title}`)}</p>
      {children}
    </div>
  )
}

export default FormHeader
